import createReduxForm from './createReduxForm';
import plain from './structure/plain';

export default createReduxForm(plain);


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-form/es/reduxForm.js
// module id = 1359
// module chunks = 0